import { render, staticRenderFns } from "./hallOfFamePost.vue?vue&type=template&id=2cf87eb4&scoped=true&"
import script from "./hallOfFamePost.vue?vue&type=script&lang=js&"
export * from "./hallOfFamePost.vue?vue&type=script&lang=js&"
import style0 from "./hallOfFamePost.vue?vue&type=style&index=0&id=2cf87eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf87eb4",
  null
  
)

export default component.exports